import { useEffect, useState } from "react"

const useImagePreload = (src) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (!src) {
      setLoaded(false)
      return undefined
    }

    setLoaded(false)
    let cancelled = false
    const img = new Image()

    const markLoaded = () => {
      if (!cancelled) setLoaded(true)
    }

    img.onload = markLoaded
    img.onerror = markLoaded
    img.src = src

    if (img.complete) markLoaded()

    return () => {
      cancelled = true
    }
  }, [src])

  return loaded
}

export default useImagePreload
